import React from 'react'
import PropTypes from 'prop-types'

import Card from '@components/card'
import Title from '@components/text/title'

import 'material-icons/iconfont/filled.css'

import {
  Container, IconAdd, Text, IconAndText, AddButtonModal
} from './styles'

const BeneficiaryAdd = ({ openAddBeneficiaryModal }) => {
  const handleClickModalAddBeneficiary = () => {
    openAddBeneficiaryModal(true)
  }

  return (
    <Card style={{ marginTop: 'auto' }}>
      <Container>
        <Title>Beneficiários</Title>
        <AddButtonModal
          onClick={handleClickModalAddBeneficiary}
        >
          <IconAndText>
            <IconAdd className="material-icons">person_add_alt_1</IconAdd>
            <Text>Cadastrar novo</Text>
          </IconAndText>
        </AddButtonModal>
      </Container>
    </Card>
  )
}

BeneficiaryAdd.propTypes = {
  openAddBeneficiaryModal: PropTypes.func.isRequired,
}

export default BeneficiaryAdd
